// TEMP: Hapus setelah pergantian KTT resmi
import moment from "moment";

/**
 * Jadwal nama OHS Dept. Head.
 * Urutkan dari tanggal terlama ke terbaru.
 *
 * Untuk pergantian berikutnya, cukup tambah baris baru di bawah:
 * { effectiveFrom: "YYYY-MM-DD", name: "Nama Baru", title: "Jabatan" }
 *
 * Entri yang berlaku = entri terakhir yang effectiveFrom <= tanggal referensi.
 */
const OHS_DEPT_HEAD_SCHEDULE = [
  {
    effectiveFrom: "2022-01-01",
    name: "Yogi Swasono",
    title: "OHS Dept. Head",
  },
  {
    effectiveFrom: "2026-07-24",
    name: "Mochamad Teguh Arifiyanto",
    title: "OHS Dept. Head",
  },
];

function getActiveOhsEntry(referenceDate = new Date()) {
  const date = moment(referenceDate).startOf("day");
  let activeEntry = OHS_DEPT_HEAD_SCHEDULE[0];

  for (const entry of OHS_DEPT_HEAD_SCHEDULE) {
    const effectiveDate = moment(entry.effectiveFrom, "YYYY-MM-DD").startOf(
      "day",
    );
    if (!date.isBefore(effectiveDate)) {
      activeEntry = entry;
    }
  }

  return activeEntry;
}

/**
 * Mengembalikan nama OHS Dept. Head berdasarkan tanggal referensi.
 * @param {Date|string|moment.Moment} [referenceDate=new Date()]
 */
export function getOHSDeptHeadName(referenceDate = new Date()) {
  return getActiveOhsEntry(referenceDate).name;
}

/**
 * Mengembalikan jabatan OHS Dept. Head berdasarkan tanggal referensi.
 * @param {Date|string|moment.Moment} [referenceDate=new Date()]
 */
export function getOHSDeptHeadTitle(referenceDate = new Date()) {
  return getActiveOhsEntry(referenceDate).title;
}

